<script setup>
    import { defineAsyncComponent, ref, computed, onMounted  } from 'vue'
    import { useNotifyStore } from '@/stores/notify'
    import useIframeControl from '@/hooks/iframeNotify'

    const ModalNotify = defineAsyncComponent(() => import('@/components/Modal/ModalNotify.vue'))

    const iframe = useIframeControl()
    const notifyStore = useNotifyStore()

    const open = ref(true)
    const loading = ref(false)

    function handleExec() {
        console.log('handleExec')
    }
    function handleClose() {
        open.value = false
    }

    async function handleInitialize() {
        try {
            await notifyStore.initialize()
            open.value = true
        } catch (error) {
            console.error(error)
            router.push({ name: 'NotFound', params: { to: 'app' } })
        }
    }

    const state = computed(() => {
        if(notifyStore.all.length > 0) return notifyStore.all[0]
        return null
    } )

    onMounted(() => {
        iframe.updateCoreValuesOnStore()
        handleInitialize()
    })

</script>
<template>
    <ModalNotify
        v-if="state"
        :show="open"
        :type="state.type"
        :title="state.title"
        :content="state.content"
        :exec-button="state.exec"
        :loading="loading"
        @exec-button="handleExec"
        @close-modal="handleClose"
    />
</template>
